import { getConfluencePlaceholderTemplate } from './controllers/confluence-templates.tsx';
import { useTargeting, type PlaceholderTargeting } from './controllers/targeting.tsx';
import { useAdControls } from './controllers/ad-controls.tsx';
import {
	usePlaceholderUiProps,
	type PlaceholderUiProps,
} from './controllers/placehoder-ui-props.tsx';
import { useConfluenceAccess } from './controllers/confluence-access.tsx';

export type Props = {
	placeholderTarget: PlaceholderTargeting | undefined;
	onDismissPlaceholderTemplate: () => Promise<void>;
	placeholderUiProps?: PlaceholderUiProps;
	onProvisioningStarted: () => void;
};

export const usePlaceholderTemplate = (
	projectType: string | undefined,
	issueType: string | undefined,
	hasActivatedConfluenceWithinFourteenDays: boolean,
	projectName: string | undefined,
): Props => {
	const {
		isConfluenceRecentlyProvisioned,
		hasConfluenceAccess,
		onProvisioningStarted,
		isConfluenceProvisioningStarted,
	} = useConfluenceAccess();

	const placeholderTarget = useTargeting(
		projectType,
		issueType,
		hasActivatedConfluenceWithinFourteenDays,
		hasConfluenceAccess,
		isConfluenceProvisioningStarted,
	);

	const template = getConfluencePlaceholderTemplate(issueType);

	const { hasDismissed, onDismissPlaceholderTemplate } = useAdControls(placeholderTarget);

	const placeholderUiProps = usePlaceholderUiProps(
		placeholderTarget,
		template,
		projectName,
		isConfluenceRecentlyProvisioned,
	);

	return {
		placeholderTarget: hasDismissed ? undefined : placeholderTarget,
		onDismissPlaceholderTemplate,
		placeholderUiProps,
		onProvisioningStarted,
	};
};
